import { type ActionArgs, assertEvent, assign } from 'xstate5';

import { type Context, generateInitialContext } from './context';
import { type Event } from './event';

// ─────────────────────────────────────────────────────────────────────────────

const toggleRestrictions: Action = assign((args) => {
  const { context, event } = args;

  assertEvent(event, 'TOGGLE_RESTRICTION');

  const { pendingRestrictions } = context;
  const maybePendingRestriction = pendingRestrictions[event.value] ?? false;

  return {
    pendingRestrictions: {
      ...pendingRestrictions,
      [event.value]: !maybePendingRestriction,
    },
  };
});

const resetPendingChanges: Action = assign((args) => {
  const { restrictions } = args.context;

  return {
    pendingRestrictions: { ...restrictions },
  };
});

const confirmPendingChanges: Action = assign((args) => {
  const { pendingRestrictions } = args.context;

  return {
    restrictions: { ...pendingRestrictions },
  };
});

const resetRestrictions: Action = assign(generateInitialContext());

// ─────────────────────────────────────────────────────────────────────────────

export const Actions = {
  toggleRestrictions,
  resetPendingChanges,
  confirmPendingChanges,
  resetRestrictions,
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Action<ActionParams extends Record<string, unknown> | void = void> = (
  actionArgs: ActionArgs<Context, Event, Event>,
  params: ActionParams,
) => void;
